import { Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Stack } from "@mui/system";
import { useEffect, useMemo, useRef, useState } from "react";
import Cancel from "@mui/icons-material/Cancel";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Config from "../../../Constants/Config";
import { ciUrl } from "../../../Constants/nodeCi";
import {
  fetchGroupAPI,
  submitCreateGroupForm,
} from "../../../Redux/features/SettingSetup/SettingSetupSlice";
import {
  getAuthInvalidMessage,
  handleGetStoreRecord,
  resendOTP,
} from "../../../Redux/features/Authentication/loginSlice";
import { OTPModal } from "../../Layout/OTPModal";
import SwitchToBackButton from "../../../reuseableComponents/SwitchToBackButton";
import useDebounce from "../../../hooks/useDebouncs";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import AsyncSelect from "react-select/async";
import { fetchStoreList } from "../../../Redux/features/StoreSettingOption/StoreSettingOptionSlice";
import AlertModal from "../../../reuseableComponents/AlertModal";
import ConfirmModal from "../../../reuseableComponents/ConfirmModal";

const CreateGroup = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // console.log("location: ", location);
  const dispatch = useDispatch();
  const { storeLoadingStatus } = useSelector((state) => state.settingStoreOption);
  const wrapperRef = useRef(null);

  const [tags, setTags] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [error, setError] = useState({
    tags: "",
    groupName: "",
  });
  const [storeValue, setStoreValue] = useState("");
  const debouncedValue = useDebounce(storeValue);
  const [groupName, setGroupName] = useState("");
  const {
    LoginGetDashBoardRecordJson,
    LoginAllStore,
    userTypeData,
    GetSessionLogin,
  } = useAuthDetails();
  const merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const login_user_email = LoginGetDashBoardRecordJson?.data?.email;
  const login_employee_id =
    LoginGetDashBoardRecordJson?.employee_id ||
    LoginGetDashBoardRecordJson?.data?.employee_id ||
    "";
  const [resolvedStoreLookupEmail, setResolvedStoreLookupEmail] = useState(
    ""
  );
  const resolvedEmailKeyRef = useRef("");
  const employeeLookupCancelRef = useRef(null);
  const storeLookupCancelRef = useRef(null);
  const allStoresPrefetchCancelRef = useRef(null);
  const allAvailableStoresRef = useRef([]);
  const groupFetchCancelRef = useRef(null);
  const login_type = userTypeData?.login_type || "";
  const auth_token = userTypeData?.token || "";
  const auth_token_id = userTypeData?.token_id || "";
  const auth_session_id = userTypeData?.session_id || "";
  const [isLookupEmailReady, setIsLookupEmailReady] = useState(
    login_type !== "manager"
  );
  const navigate = useNavigate();

  const isEdit = useMemo(
    () => location.pathname.includes("edit-group"),
    [location]
  );
  const selectedGroupId = useMemo(
    () => location?.state?.id || searchParams.get("id"),
    [location?.state?.id, searchParams]
  );
  const [loading, setLoading] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);
  const [sessionRefreshLoading, setSessionRefreshLoading] = useState(false);
  const [pendingSessionStore, setPendingSessionStore] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmfinalModalOpen, setConfirmFinalModalOpen] = useState(false);
  const [removedStoreConfirmOpen, setRemovedStoreConfirmOpen] = useState(false);
  const [mergeGroupConfirmOpen, setMergeGroupConfirmOpen] = useState(false);
  const [createGroupConfirmOpen, setCreateGroupConfirmOpen] = useState(false);
  const [initialMerchantIds, setInitialMerchantIds] = useState([]);
  const [allAvailableStores, setAllAvailableStores] = useState([]);
  const [selectAllLoading, setSelectAllLoading] = useState(false);

  const MERGE_STORES_CONFIRM_MESSAGE =
    "Adding stores to this group will merge customer and loyalty data across the selected stores and enable syncing for all included stores. Users may be required to re-login on Web and POS for changes to take effect.";

  const CREATE_GROUP_MERGE_CONFIRM_MESSAGE =
    "Merging these stores will combine customer, loyalty, and store credit data across all locations. After merging, all users must manually log out and log in again on both the Web and POS for the changes to take effect. Please inform your staff to log out and log in again after this change.";

  const currentSessionStore = useMemo(
    () => ({
      merchant_id,
      name: LoginGetDashBoardRecordJson?.data?.name || "",
      login_store_name: LoginGetDashBoardRecordJson?.data?.name || "",
    }),
    [merchant_id, LoginGetDashBoardRecordJson?.data?.name]
  );

  useEffect(() => {
    if (otpTimer <= 0) return;
    const interval = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [otpTimer]);

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchGroupData = async () => {
    if (groupFetchCancelRef.current) {
      groupFetchCancelRef.current.cancel("Cancelled previous group fetch");
    }
    const source = axios.CancelToken.source();
    groupFetchCancelRef.current = source;
    const formData = new FormData();
    formData.append("merchant_id", merchant_id);
    formData.append("group_id", selectedGroupId);
    formData.append("email", login_user_email);

    await dispatch(fetchGroupAPI({ formData, cancelToken: source.token }))
      .unwrap()
      .then((res) => {
        if (res?.status) {
          const groupData = res?.data?.find((grp) => grp.id == selectedGroupId);
          if (!groupData) return;
          setGroupName(groupData?.name);
          const merchantArr = groupData?.merchants?.trim()?.split(",") || [];
          setInitialMerchantIds(merchantArr.filter(Boolean));
          const fetchTagList = dropdownOptions?.filter(
            (res) => merchantArr?.includes(res?.value) // ✅ match against value
          );
          const normalizedTags = fetchTagList.map((tag) => ({
            name: tag.label,
            merchant_id: tag.value,
          }));
          if (tags.length === 0 && normalizedTags.length > 0) {
            setTags(normalizedTags);
          }
        }
      })
      .catch((error) => {
        if (error?.cancelled) return;
        console.log("Error", error);
      });
  };

  useEffect(() => {
    if (isEdit && selectedGroupId) {
      fetchGroupData();
    }
    return () => {
      if (groupFetchCancelRef.current) {
        groupFetchCancelRef.current.cancel("Cleanup group fetch");
      }
    };
  }, [isEdit, selectedGroupId, dropdownOptions, resolvedStoreLookupEmail]);

  useEffect(() => {
    const resolveLookupEmail = async () => {
      if (login_type !== "manager") {
        setResolvedStoreLookupEmail(login_user_email || "");
        setIsLookupEmailReady(true);
        return;
      }

      const resolveKey = `${login_type}|${merchant_id}|${login_employee_id}|${auth_token}`;
      if (resolvedEmailKeyRef.current === resolveKey) {
        return;
      }
      setIsLookupEmailReady(false);

      try {
        if (employeeLookupCancelRef.current) {
          employeeLookupCancelRef.current.cancel("Cancelled previous employee lookup");
        }
        const source = axios.CancelToken.source();
        employeeLookupCancelRef.current = source;
        const payload = {
          merchant_id: merchant_id?.toUpperCase?.() || merchant_id,
          employee_id: login_employee_id,
          login_type,
          token: auth_token,
          token_id: auth_token_id,
          session_id: auth_session_id,
        };
        const response = await axios.post(
          ciUrl(Config.EMPLOYEE_DATA),
          payload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${auth_token}`,
            },
            cancelToken: source.token,
          }
        );

        const employeeEmail =
          response?.data?.result?.email

        const finalEmail = employeeEmail || login_user_email || "";
        setResolvedStoreLookupEmail(finalEmail);
        resolvedEmailKeyRef.current = resolveKey;
        setIsLookupEmailReady(true);
      } catch (error) {
        if (axios.isCancel(error)) {
          return;
        }
        setResolvedStoreLookupEmail(login_user_email || "");
        setIsLookupEmailReady(true);
      }
    };

    resolveLookupEmail();
    return () => {
      if (employeeLookupCancelRef.current) {
        employeeLookupCancelRef.current.cancel("Component cleanup employee lookup");
      }
    };
  }, [
    login_type,
    login_employee_id,
    merchant_id,
    login_user_email,
    auth_token,
    auth_token_id,
    auth_session_id,
  ]);

  const loadStoresFromApi = async (
    inputValue = "",
    cancelRef = storeLookupCancelRef
  ) => {
    if (login_type === "manager" && !isLookupEmailReady) {
      return [];
    }
    if (cancelRef.current) {
      cancelRef.current.cancel("Cancelled previous store lookup");
    }
    const source = axios.CancelToken.source();
    cancelRef.current = source;
    const payload = {
      name: inputValue,
      merchant_id: merchant_id,
      ...userTypeData,
      // email: resolvedStoreLookupEmail || GetSessionLogin?.username,
      email: userTypeData?.login_type === "superadmin" ? LoginGetDashBoardRecordJson?.data?.email : GetSessionLogin?.username,
      cancelToken: source.token,
    };

    try {
      const response = await dispatch(fetchStoreList(payload)).unwrap();
      if (response?.status && response.data?.length > 0) {
        return response.data;
      }
      return [];
    } catch (error) {
      if (error?.cancelled) {
        return [];
      }
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  useEffect(() => {
    allAvailableStoresRef.current = allAvailableStores;
  }, [allAvailableStores]);

  useEffect(() => {
    if (!isLookupEmailReady) return undefined;

    let cancelled = false;
    const loadAllStores = async () => {
      const stores = await loadStoresFromApi("", allStoresPrefetchCancelRef);
      if (!cancelled) {
        setAllAvailableStores(stores);
      }
    };
    loadAllStores();

    return () => {
      cancelled = true;
      if (allStoresPrefetchCancelRef.current) {
        allStoresPrefetchCancelRef.current.cancel("Cleanup all-stores prefetch");
      }
    };
  }, [
    isLookupEmailReady,
    resolvedStoreLookupEmail,
    merchant_id,
    login_type,
  ]);

  const selectDefaultOptions = useMemo(() => {
    if (!isLookupEmailReady) return false;
    if (!allAvailableStores.length) return true;
    return allAvailableStores
      .filter(
        (store) =>
          !tags.some((tag) => tag.merchant_id === store.merchant_id)
      )
      .map((store) => ({
        label: store.name,
        value: store.merchant_id,
      }));
  }, [isLookupEmailReady, allAvailableStores, tags]);

  const isAllStoresSelected = useMemo(() => {
    if (!allAvailableStores.length || !tags.length) return false;
    if (tags.length !== allAvailableStores.length) return false;
    const availableIds = new Set(
      allAvailableStores.map((store) => store.merchant_id)
    );
    return tags.every((tag) => availableIds.has(tag.merchant_id));
  }, [tags, allAvailableStores]);

  const handleSelectAllStores = async (event) => {
    const checked = event.target.checked;
    if (!checked) {
      setTags([]);
      setError((prev) => ({ ...prev, tags: "" }));
      return;
    }

    setSelectAllLoading(true);
    try {
      const stores =
        allAvailableStores.length > 0
          ? allAvailableStores
          : await loadStoresFromApi("", allStoresPrefetchCancelRef);

      if (!stores.length) {
        ToastifyAlert("No stores found", "warn");
        return;
      }

      if (!allAvailableStores.length) {
        setAllAvailableStores(stores);
      }

      setTags(
        stores.map((store) => ({
          name: store.name,
          merchant_id: store.merchant_id,
        }))
      );
      setError((prev) => ({ ...prev, tags: "" }));
    } finally {
      setSelectAllLoading(false);
    }
  };

  // fetch all manager stores (dropdown — separate cancel token from prefetch)
  const fetchStoreData = async (inputValue = "") => {
    const search = (inputValue || "").trim();
    let stores;

    if (!search && allAvailableStoresRef.current.length) {
      stores = allAvailableStoresRef.current;
    } else {
      stores = await loadStoresFromApi(inputValue);
      if (!search && stores.length) {
        setAllAvailableStores(stores);
      }
    }

    if (!stores.length) {
      return [];
    }

    const filteredStores = stores.filter(
      (store) => !tags.some((tag) => tag.merchant_id === store.merchant_id)
    );

    const normalizedTags = filteredStores.map((store) => ({
      label: store.name,
      value: store.merchant_id,
    }));
    setDropdownOptions(normalizedTags);
    return normalizedTags;
  };

  const handleOnInputChange = async (e) => {
    e.stopPropagation();
    const { value } = e.target;
    setStoreValue(value);
  };

  const handleTagSelect = (selectedTag) => {
    const merchantId = selectedTag.merchant_id;
    if (!tags.some((tag) => tag.merchant_id === merchantId)) {
      setTags((prevTags) => [...prevTags, selectedTag]);
    }
    setIsDropdownVisible(false);
  };

  const handleRemoveTag = (e, indexToRemove) => {
    e.stopPropagation();
    const updatedTags = tags.filter((_, index) => index !== indexToRemove);
    setTags(updatedTags);
  };

  const completeSessionRefreshSuccess = () => {
    setIsOTPModalOpen(false);
    setPendingSessionStore(null);
    setOtpError("");
    navigate("/customer-management/customer-groups");
    window.location.reload();
  };

  const navigateToGroupsWithSessionWarning = () => {
    ToastifyAlert(
      "Group saved. Log out and log back in if customer data does not reflect the change.",
      "info"
    );
    navigate("/customer-management/customer-groups");
  };

  const handleResendOTP = async () => {
    const store = pendingSessionStore || currentSessionStore;
    if (otpTimer > 0 || !store?.merchant_id) return;
    try {
      await dispatch(
        resendOTP({
          username: GetSessionLogin?.username,
          password: GetSessionLogin.password,
          merchant_id: store.merchant_id,
          storename: store.login_store_name,
        })
      );
      setOtpTimer(30);
      setOtpError("");
    } catch (err) {
      console.error("Error resending OTP:", err);
      setOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleOnSubmitOTP = (otp, trustDeviceFlag) => {
    if (!pendingSessionStore && !currentSessionStore?.merchant_id) return;
    setOtpError("");
    refreshSessionAfterGroupChange(false, otp, trustDeviceFlag);
  };

  /** Re-issue session via create_session (same flow as Header handleChangeMerchant). */
  const refreshSessionAfterGroupChange = (
    isInitialAttempt = false,
    otp = "",
    trustDeviceFlag = false
  ) => {
    if (!GetSessionLogin?.username || !GetSessionLogin?.password) {
      navigateToGroupsWithSessionWarning();
      return Promise.resolve();
    }

    const storeContext = pendingSessionStore || currentSessionStore;
    let emp_id = 0;
    if (localStorage.getItem("emp_id")) {
      emp_id = localStorage.getItem("emp_id");
    }

    const data = {
      username: GetSessionLogin.username,
      password: GetSessionLogin.password,
      login_type:
        LoginGetDashBoardRecordJson?.login_type || login_type || "",
      merchant_id: storeContext?.merchant_id,
      employee_id: emp_id,
      trust_device: trustDeviceFlag ? "1" : "0",
    };

    if (otp) {
      data.otp = otp;
    }

    const storedDeviceToken = localStorage.getItem("qv_device_token");
    if (storedDeviceToken) {
      data.device_token = storedDeviceToken;
    }

    setSessionRefreshLoading(true);
    return dispatch(handleGetStoreRecord(data))
      .then((result) => {
        if (
          result?.payload?.status === true &&
          result?.payload?.otp_required === 1 &&
          isInitialAttempt
        ) {
          setIsOTPModalOpen(true);
          setPendingSessionStore(storeContext);
          setOtpError("");
          setOtpTimer(30);
          return;
        }

        if (
          result?.payload?.status === false &&
          result?.payload?.otp_required === 1
        ) {
          const msg = result?.payload?.msg || "Invalid or expired OTP";
          setOtpError(msg);
          setIsOTPModalOpen(true);
          setPendingSessionStore(storeContext);
          return;
        }

        if (
          result?.payload?.status === false &&
          isInitialAttempt &&
          result?.payload?.msg &&
          (result?.payload?.msg.toLowerCase().includes("wait") ||
            result?.payload?.msg.toLowerCase().includes("otp"))
        ) {
          const msg =
            result?.payload?.msg ||
            "Please wait before requesting a new OTP";
          setOtpError(msg);
          setIsOTPModalOpen(true);
          setPendingSessionStore(storeContext);
          return;
        }

        if (result?.payload?.status === true) {
          if (result?.payload?.final_login === 1) {
            completeSessionRefreshSuccess();
          }
          return;
        }

        if (isOTPModalOpen) {
          const msg = result?.payload?.msg || "Authentication failed";
          setOtpError(msg);
        } else {
          dispatch(getAuthInvalidMessage(result?.payload?.msg));
          navigate("/login");
        }
      })
      .catch((err) => {
        if (isOTPModalOpen) {
          setOtpError("An error occurred. Please try again.");
        } else {
          console.error("Session refresh after group change failed:", err);
          navigateToGroupsWithSessionWarning();
        }
      })
      .finally(() => {
        setSessionRefreshLoading(false);
      });
  };

  const submitForm = async () => {
    if (loading) return;
    setLoading(true);
    const formData = new FormData();
    formData.append(
      "merchant_ids",
      tags
        ?.map((i) => i.merchant_id)
        .join(",")
        .trim()
    );
    formData.append("name", groupName.trim() ?? "");
    formData.append("email", login_user_email ?? "");
    formData.append("group_id", selectedGroupId ?? "");

    try {
      const res = await dispatch(
        submitCreateGroupForm({ isEdit, formData })
      ).unwrap();

      if (res.status) {
        ToastifyAlert(res.message, "success");
        await refreshSessionAfterGroupChange(true);
      } else {
        // ❌ Error case
        let msg = res.message;

        // extract merchant ID from error message
        const match = msg.match(/Merchant ID '([^']+)'/);
        if (match) {
          const merchantId = match[1];
          let merchantName = merchantId;

          // lookup merchant in dropdownOptions
          const found = dropdownOptions.find(
            (option) =>
              option.value === merchantId || option.merchant_id === merchantId
          );

          if (found) {
            merchantName = found.label || found.name;
          }

          // replace only the merchantId with merchantName
          msg = msg.replace(merchantId, merchantName);
        }

        ToastifyAlert(msg, "error");
      }
    } catch (error) {
      console.log("Error", error);
      ToastifyAlert(error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitStore = () => {
    if (loading) return;
    let tagError = "";
    let groupError = "";
    // if (!tags?.length) {
    //   tagError = "Store is Required";
    // }
    // if (tags?.length > 0 && tags?.length < 2) {
    //   tagError = "Minimum 2 store is Required";
    // }
    if (!tags?.length && !isEdit) {
      tagError = "Minimum 1 store is Required";
    }
    if (!groupName.trim()) {
      groupError = "Group Name is Required";
    }
    const selectedMerchantIds = tags?.map((tag) => tag.merchant_id) || [];
    const removedStoreIds = initialMerchantIds.filter(
      (merchantId) => !selectedMerchantIds.includes(merchantId)
    );
    const addedStoreIds = selectedMerchantIds.filter(
      (merchantId) => !initialMerchantIds.includes(merchantId)
    );
    if (isEdit && removedStoreIds.length > 0) {
      setRemovedStoreConfirmOpen(true);
      return;
    }
    if (!tags?.length && isEdit && groupName) {
      setConfirmModalOpen(true);
      return;
    }

    setError((prev) => ({
      ...prev,
      tags: tagError,
      groupName: groupError,
    }));

    if (tagError === "" && groupError === "") {
      const needsMergeConfirm = addedStoreIds.length > 0;
      if (needsMergeConfirm && isEdit) {
        setMergeGroupConfirmOpen(true);
        return;
      }
      if (!isEdit && tags?.length > 0) {
        setCreateGroupConfirmOpen(true);
        return;
      }
      submitForm();
    }

    // if (!error.tags && !error.groupName) {
    //   // called API
    //   submitForm();
    // }
  };


  const confirmfun = () => {
    submitForm();
  };
  const confirmRemovedStoresUpdate = () => {
    setRemovedStoreConfirmOpen(false);
    const selectedMerchantIds = tags?.map((tag) => tag.merchant_id) || [];
    const addedStoreIds = selectedMerchantIds.filter(
      (merchantId) => !initialMerchantIds.includes(merchantId)
    );
    if (addedStoreIds.length > 0) {
      setMergeGroupConfirmOpen(true);
      return;
    }
    submitForm();
  };

  const confirmMergeGroup = () => {
    setMergeGroupConfirmOpen(false);
    submitForm();
  };

  const confirmCreateGroup = () => {
    setCreateGroupConfirmOpen(false);
    submitForm();
  };
  // console.log("tags: ", tags);
  // console.log("dropdownOptions: ", dropdownOptions);
  return (
    <>
      <Grid
        container
        className="box_shadow_div"
      // style={{ overflow: "visible" }}
      >
        <SwitchToBackButton
          linkTo={"/customer-management/customer-groups"}
          title={`${isEdit ? "Update" : "Create"} Customer Group`}
        />
        <Grid item xs={12} sx={{ py: 2.5, px: { xs: 1, sm: 2.5 } }}>
          {!isEdit && (
            <Grid container sx={{ mb: 1 }}>
              <Grid item xs={12}>
                <p
                  style={{
                    marginBottom: "8px",
                    fontFamily: "CircularSTDMedium",
                    color: "var(--qv-tx-000000, #000000)",
                  }}
                >
                  Important
                </p>
                <ul className="info-unorder inforecord-email">
                  <li>Customer profiles shared</li>
                  <li>Loyalty points redeemable anywhere</li>
                  <li>Store credit usable anywhere</li>
                  <li>Gift cards accepted anywhere</li>
                  <li>Loyalty settings synchronized</li>
                  <li>Orders visible only in originating store</li>
                </ul>
              </Grid>
            </Grid>
          )}
          <Box className="tagifyInput" sx={{ width: "100%" }} ref={wrapperRef}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "6px",
              }}
            >
              <label htmlFor="storeInput">Stores</label>
              <label
                className="q_resigter_setting_section qv-select-all-stores"
                style={{
                  color: "var(--qv-tx-000000, #000)",
                  fontSize: "14px",
                  marginBottom: 0,
                  marginRight: 0,
                  paddingLeft: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  lineHeight: "20px",
                }}
              >
                Select all stores
                <input
                  type="checkbox"
                  id="selectAllStores"
                  checked={isAllStoresSelected}
                  onChange={handleSelectAllStores}
                  disabled={
                    selectAllLoading ||
                    (login_type === "manager" && !isLookupEmailReady)
                  }
                />
                <span
                  className="checkmark"
                  style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    opacity:
                      selectAllLoading ||
                        (login_type === "manager" && !isLookupEmailReady)
                        ? 0.6
                        : 1,
                  }}
                />
              </label>
            </Box>
            <AsyncSelect
              key={`store-group-select-${login_type}-${isLookupEmailReady ? "ready" : "pending"}-${resolvedStoreLookupEmail || ""}`}
              classNamePrefix="qv-store-select"
              cacheOptions
              cacheUniqs={[
                resolvedStoreLookupEmail,
                isLookupEmailReady,
                allAvailableStores.length,
                tags.map((t) => t.merchant_id).join(","),
              ]}
              defaultOptions={selectDefaultOptions}
              isMulti
              isLoading={storeLoadingStatus || (login_type === "manager" && !isLookupEmailReady)}
              loadingMessage={() => "Loading stores..."}
              noOptionsMessage={() =>
                login_type === "manager" && !isLookupEmailReady
                  ? "Loading stores..."
                  : "No stores found"
              }
              loadOptions={fetchStoreData}
              placeholder="Search Store"
              // ✅ convert tags into { label, value }
              value={tags.map((tag) => ({
                label: tag.name,
                value: tag.merchant_id,
              }))}
              onChange={(selected) => {
                const updatedTags = (selected || []).map((item) => ({
                  name: item.label,
                  merchant_id: item.value,
                }));
                setTags(updatedTags);
              }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Box>

          <span className="error-alert">{error?.tags}</span>
          <form action=""></form>
          <div className="mt-5 w-50">
            <label htmlFor="storeInputName">
              Group Name<span className="Asterisk_error"></span>
            </label>
            <input
              id="storeInputName"
              type="text"
              placeholder="Enter Group Name"
              className="group_name_field my-4"
              maxLength={50}
              value={groupName}
              style={{ width: "50%" }}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </div>
          <span className="error-alert">{error?.groupName}</span>
        </Grid>

        <Grid className="" style={{ width: "100%" }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              mb: 0,
              py: 2.5,
              px: { xs: 1, sm: 2.5 },
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              backgroundColor: "var(--qv-bg-ffffff, #fff)",
              overflow: "hidden",
            }}
          >
            <div className=" md:mr-0">
              <div className="col-qv-12">
                <div
                  style={{ padding: 0 }}
                  className="q-add-categories-section-middle-footer"
                >
                  <button
                    type="button"
                    className="quic-btn quic-btn-save attributeUpdateBTN"
                    onClick={handleSubmitStore}
                    disabled={loading}
                  >
                    {loading && (
                      <CircularProgress
                        color={"inherit"}
                        className="loaderIcon"
                        width={15}
                        size={15}
                      />
                    )}
                    {isEdit ? "Update" : "Create"}
                  </button>

                  <Link
                    to={`/customer-management/customer-groups`}
                    className="quic-btn quic-btn-cancle"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <ConfirmModal
        headerText="A minimum of 1 store is required, otherwise this group will be deleted."
        open={confirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
        }}
        onConfirm={confirmfun}
      />
      <ConfirmModal
        headerText="Removing a store from this group will stop future customer and loyalty syncing for that store and will require re-login on Web and POS."
        titleSuggestion="Confirm"
        open={removedStoreConfirmOpen}
        onClose={() => {
          setRemovedStoreConfirmOpen(false);
        }}
        onConfirm={confirmRemovedStoresUpdate}
      />
      <ConfirmModal
        headerText={MERGE_STORES_CONFIRM_MESSAGE}
        titleSuggestion="Confirm"
        open={mergeGroupConfirmOpen}
        onClose={() => {
          setMergeGroupConfirmOpen(false);
        }}
        onConfirm={confirmMergeGroup}
      />
      <ConfirmModal
        headerText={CREATE_GROUP_MERGE_CONFIRM_MESSAGE}
        titleSuggestion="Confirm"
        open={createGroupConfirmOpen}
        onClose={() => {
          setCreateGroupConfirmOpen(false);
        }}
        onConfirm={confirmCreateGroup}
      />
      <OTPModal
        isOpen={isOTPModalOpen}
        onClose={() => {
          setIsOTPModalOpen(false);
          setPendingSessionStore(null);
          setOtpError("");
        }}
        shopName={pendingSessionStore?.name || currentSessionStore?.name}
        onSubmit={handleOnSubmitOTP}
        onResend={handleResendOTP}
        otpTimer={otpTimer}
        errorMessage={otpError}
        isLoading={sessionRefreshLoading}
      />
    </>
  );
};

export default CreateGroup;
